import React, { useEffect } from "react";
import {
  I2cRadio,
  I2cListItem,
  I2cRadioGroup,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
export const textService = [
  { label: "i2c Inc.’s default short code", value: "default-short-code" },
  { label: "A dedicated short code", value: "dedicated-short-code" },
];
export const shortCodeAcquire = [
  { label: "i2c default short code", value: "i2c-default-short-code" },
  {
    label: "i2c to procure dedicated short code",
    value: "procure-dedicated-short-code",
  },
];
export const textPurpose = [
  { label: "Deliver alerts and notifications (MT Only)", value: "mt-only" },
  { label: "Dual communication (Both MO and MT)", value: "both-mo-and-mt" },
];
const MobileTextMessage = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    ov_mtm_service_code: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    ov_mtm_service_short_code: Yup.string().when("ov_mtm_service_code", {
      is: (code) => code && code === "dedicated-short-code",
      then: () =>
        Yup.string()
          .required("Dedicated short code is required")
          .min(1, "Dedicated short code other is required."),
      otherwise: () => Yup.string().optional(),
    }),
    ov_mtm_service_use: Yup.string().required(generalErrorMessage),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      ov_mtm_service_code: "",
      ov_mtm_service_short_code: "",
      ov_mtm_service_use: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "ov_mtm_service_code",
    "ov_mtm_service_short_code",
    "ov_mtm_service_use",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[6]["6_6"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      6: {
        ...addFormData["6"],
        "6_6": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("6_6", true);
    else setFormValidStates("6_6", false);
  }, [Object.keys(errors).length]);
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="ov_mtm_service_code"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="For text message service, would you like to use i2c short code?"
                    {...field}
                    onI2cChange={(e) => {
                      if (e.target.value !== "dedicated-short-code") {
                        methods.setValue("ov_mtm_service_short_code", "");
                      }
                      methods.setValue("ov_mtm_service_code", e.target.value);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid grid-sm">
                      {textService.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={radio.label}
                          sublabel=" "
                          value=""
                          type="checkbox"
                          checked={
                            methods.watch("ov_mtm_service_code") === radio.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            checked={
                              methods.watch("ov_mtm_service_code") ===
                              radio.value
                            }
                            filled
                            value={radio.value}
                          />
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("ov_mtm_service_code") === "dedicated-short-code" && (
            <div i2c-grid="12">
              <div className="single-field-wrapper">
                <Controller
                  name="ov_mtm_service_short_code"
                  control={control}
                  render={({ field }) => (
                    <I2cRadioGroup
                      label="Acquire short code for text messaging:"
                      {...field}
                      onI2cChange={(e) => {
                        methods.setValue(
                          "ov_mtm_service_short_code",
                          e.target.value,
                        );
                        methods.trigger();
                        handleValueChanges();
                      }}
                    >
                      <div i2c-grid="grid grid-sm">
                        {shortCodeAcquire.map((radio, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            variant="receipt"
                            label={radio.label}
                            sublabel=" "
                            value=""
                            type="checkbox"
                            checked={
                              methods.getValues("ov_mtm_service_short_code") ===
                              radio.value
                            }
                          >
                            <I2cRadio
                              slot="prefix"
                              checked={
                                methods.getValues(
                                  "ov_mtm_service_short_code",
                                ) === radio.value
                              }
                              filled
                              value={radio.value}
                            />
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cRadioGroup>
                  )}
                />
              </div>
            </div>
          )}
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="ov_mtm_service_use"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Text messaging will be used to:"
                    {...field}
                    onI2cChange={(e) => {
                      methods.setValue("ov_mtm_service_use", e.target.value);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid grid-sm">
                      {textPurpose.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={radio.label}
                          sublabel=" "
                          value=""
                          type="checkbox"
                          checked={
                            methods.getValues("ov_mtm_service_use") ===
                            radio.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            checked={
                              methods.getValues("ov_mtm_service_use") ===
                              radio.value
                            }
                            filled
                            value={radio.value}
                          />
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MobileTextMessage;
